import { NgModule } from '@angular/core';
import { LoginComponent } from './login-password/login.component';
import { LoginProposalComponent } from './login-proposal/login-proposal.component';
import { LoginRoutingModule } from './login-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [LoginComponent, LoginProposalComponent],
  imports: [LoginRoutingModule, SharedModule],
  providers: [],
  bootstrap: [],
  exports: [LoginComponent, LoginProposalComponent],
})
export class LoginModule {}
